<script lang="ts">
  import { getStr } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import { openExtraDrawer, pdpMoreInfoActiveTab, productDetails, showPdpMoreInfoModal } from '../store/pdp_store';

  export let ProductRatingData;
  let innerWidth = window.innerWidth;

  $productDetails = window['ACC'].config.productDetails;

  const CustomerReviews = getStr('extra.pdp.customerReviews');
  const ExpertReviews = getStr('extra.pdp.expertReviews');
  const ReviewSectionText = getStr('extra.pdp.reviewSectionText');
  $: rating = (ProductRatingData?.score / 2).toFixed(1);
  $: customerReview = ProductRatingData?.user_review_count + (ProductRatingData?.your_review_count || 0);
  $: allReviewCount =
    ProductRatingData?.user_review_count +
    (ProductRatingData?.your_review_count || 0) +
    (ProductRatingData?.pro_review_count || 0);
  $: expertReview = ProductRatingData?.pro_review_count;

  function showPdpMoreInfo(activeTab) {
    $showPdpMoreInfoModal = true;
    $pdpMoreInfoActiveTab = activeTab;
  }
</script>

<svelte:window on:keydown={onkeydown} bind:innerWidth />

{#if rating !== null && +rating > 0}
  {#if innerWidth <= 900}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="customer_review_rating_section" on:click={() => showPdpMoreInfo('Reviews')}>
      <div class="icon_rating">
        <Icon glyph="icon-star" mobileSize={16} desktopSize={12} type="primary" />
        <div class="rating">{rating}</div>
      </div>
      {#if allReviewCount && allReviewCount > 0}
        <div class="dot dot_color">•</div>
        <div class="customer_review">{allReviewCount}</div>
      {/if}
    </div>
  {:else}
    <div class="customer_review_rating_section_desktop_container">
      <div class="customer_review_rating_section_desktop">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="reviewDiv" on:click={() => showPdpMoreInfo('Reviews')}>
          <Icon glyph="icon-star" mobileSize={16} desktopSize={16} type="primary" />
          <div class="customer_review_expert_review">
            <p>
              {rating}
              {#if customerReview && customerReview > 0}
                <span class="dot_color"> •</span>
                <span> {CustomerReviews} ({customerReview})</span>
              {/if}
              {#if expertReview && expertReview > 0}
                <span class="dot_color"> •</span>
                <span> {ExpertReviews} ({expertReview})</span>
              {/if}
            </p>
          </div>
        </div>
      </div>
      <div class="customer_review_rating_section_horizonatal_line" />

      {#if !$openExtraDrawer}
        <p class="customer_review_rating_section_text">{ReviewSectionText}</p>
      {/if}
    </div>
  {/if}
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .customer_review_rating_section {
    display: flex;
    width: fit-content;
    height: 24px;
    background: $primary-white;
    border: 1px solid $secondary-gray-02;
    box-shadow: 0px 4px 12px $secondary-gray-02;
    border-radius: 6px;
    font-weight: 500;
    font-size: 14px !important;
    line-height: 16px;
    align-items: center;
    color: $primary-black;
    @include desktop-max-width {
      padding: 4px 6px 4px 6px;
    }
  }

  .icon_rating {
    display: flex;
    margin: 0px 2px;
  }
  .icon_rating > div {
    margin: 0px 2px;
    font-family: 'Dubai';
  }
  .dot {
    margin-right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .dot_color {
    color: $neutral-dark-04;
  }
  .customer_review {
    padding-right: 4px;
  }
  .customer_review_rating_section_desktop {
    display: flex;
    align-items: center;
  }
  .customer_review_rating_section_desktop p {
    display: flex;
    align-items: center;
    text-align: center;
    color: $primary-black;
    margin: 0px;
    line-height: 16px;
  }

  .customer_review_rating_section_desktop span {
    margin-left: 3px;
    font-weight: 500;
  }
  .customer_review_expert_review {
    margin-left: 4px;
  }
  .customer_review_rating_section_desktop_container {
    margin: 12px 0px 0px 0px;
  }
  .customer_review_rating_section_horizonatal_line {
    margin: 4px 0px;
    height: 1px;
    width: 100%;
    background: $secondary-gray-02;
  }
  .customer_review_rating_section_text {
    margin: 0;
    margin-top: 6px;
    font-weight: 400;
    color: $neutral-dark-03;
    line-height: 16px;
    font-size: 14px;
  }
  .reviewDiv {
    display: flex;
    cursor: pointer;
  }
</style>
